import { Component, Input, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserProfileService } from '../../service/user-profile.service';

@Component({
  selector: 'app-profile-about',
  templateUrl: './profile-about.component.html',
  styleUrls: ['./profile-about.component.css'],
})
export class ProfileAboutComponent implements OnChanges {
  @Input() about: any = '';
  @Input() mode: 'view' | 'edit' = 'view';

  expanded = false;
  isEditModalOpen = false;
  isSaving = false;
  aboutForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private userProfileService: UserProfileService,
  ) {}

  ngOnChanges(): void {
    this.initForm();
  }

  initForm(): void {
    this.aboutForm = this.fb.group({
      about: [this.about || ''],
    });
  }

  get preview(): string {
    return this.about.length > 160 && !this.expanded
      ? this.about.slice(0, 160) + '...'
      : this.about;
  }

  openEditModal(): void {
    this.initForm();
    this.isEditModalOpen = true;
  }

  closeEditModal(): void {
    this.isEditModalOpen = false;
  }

  saveAbout(): void {
    this.isSaving = true;
    const formData = new FormData();
    formData.append('about', this.aboutForm.value.about || '');

    this.userProfileService.updateUserProfile(formData).subscribe({
      next: (response) => {
        this.isSaving = false;
        this.about = response.about ?? this.aboutForm.value.about;
        this.closeEditModal();
      },
      error: (error) => {
        this.isSaving = false;
      },
    });
  }
}
